import {initializeFaro} from 'shared';

import {CF_API, STUDIO_API} from '@/config';

initializeFaro({
  collectorUrl: import.meta.env.VITE_STUDIO_FARO_URL,
  appKey: import.meta.env.VITE_STUDIO_FARO_API_KEY,
  appName: 'studio-staging',
  appVersion: __APP_VERSION__,
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  tracePropagationUrls: [STUDIO_API, CF_API],
});
